import { useLocalization } from "@shared-ui/localization-context";

import ImageTop from "components/flexComponents/Hotels/views/HotelsViews/components/ImageTop/ImageTop";
import ImageLeftSmall from "components/flexComponents/Hotels/views/HotelsViews/components/ImageLeftSmall/ImageLeftSmall";
import ImageLeftLarge from "components/flexComponents/Hotels/views/HotelsViews/components/ImageLeftLarge/ImageLeftLarge";
import ImageHalf from "components/flexComponents/Hotels/views/HotelsViews/components/ImageHalf/ImageHalf";

import { Hotel } from "typings/microserviceModels/hotels-flex-module";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";

export const hotelsViewTypes = {
  "image-top": ImageTop,
  "image-left-small": ImageLeftSmall,
  "image-left-large": ImageLeftLarge,
  "image-half": ImageHalf,
};

export const topLevelViewClassName = {
  "image-top": "HotelsImageTop",
  "image-left-small": "HotelsImageLeftSmall",
  "image-left-large": "HotelsImageLeftLarge",
  "image-half": "HotelsImageHalf",
};

export const getDirectDistance = (hotel: Hotel, context: ExtendedContextStore) => {
  const { directDistance } = hotel;
  if (!directDistance) {
    return;
  }

  const { value, unit } = directDistance;
  const isValidUnit = unit === DISTANCE_UNIT.KILOMETERS || unit === DISTANCE_UNIT.MILES;
  if (!(value && isValidUnit)) {
    return;
  }

  const { location } = context.searchContext;
  const { type: locationType, name: locationName } = { ...location };
  const isPoiOrAirport = locationType === LOCATION_TYPE.AIRPORT || locationType === LOCATION_TYPE.POI;
  const originType = isPoiOrAirport ? "poiOrAirport" : "default";

  const { formatText } = useLocalization();
  const valueAsString = String(value);
  const distanceValue = Math.round(parseFloat(valueAsString) * 100) / 100;

  const distanceTextResponses = {
    km: {
      poiOrAirport: formatText("hotels.distanceToPoi.kilometers", distanceValue, locationName),
      default: formatText("nearestLocationContent.cityCenterDistance.text.km", distanceValue),
    },
    mi: {
      poiOrAirport: formatText("hotels.distanceToPoi.miles", distanceValue, locationName),
      default: formatText("nearestLocationContent.cityCenterDistance.text.mi", distanceValue),
    },
  };

  return distanceTextResponses[unit][originType];
};

export const expandoCollapsedTitle = (contentRecipe: string) => {
  const { formatText } = useLocalization();

  return contentRecipe === CONTENT_TYPE.REVIEW
    ? formatText("hotelsViews.expando.showReview")
    : formatText("hotelsViews.expando.showDetails");
};

export const expandoExpandedTitle = (contentRecipe: string) => {
  const { formatText } = useLocalization();

  return contentRecipe === CONTENT_TYPE.REVIEW
    ? formatText("hotelsViews.expando.hideReview")
    : formatText("hotelsViews.expando.hideDetails");
};

enum LOCATION_TYPE {
  AIRPORT = "airport",
  POI = "point_of_interest",
}

enum DISTANCE_UNIT {
  KILOMETERS = "km",
  MILES = "mi",
}

export enum CONTENT_TYPE {
  REVIEW = "review",
  DESCRIPTION = "description",
}

export enum CARD_LAYOUT_TYPE {
  GRID = "grid",
  LIST = "list",
}
